import DapDSToggleButton from './toggle-button.component'

export * from './toggle-button.component'
export default DapDSToggleButton

DapDSToggleButton.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-toggle-button': DapDSToggleButton
  }
}
